import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Leaf, Loader2 } from "lucide-react";
import { API, setToken } from "@/api";

export const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { username, password });
      setToken(data.token);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--cream)] px-4">
      <div className="w-full max-w-md rounded-3xl bg-white border border-[var(--border)] ambient p-8 sm:p-10">
        <div className="flex items-center gap-2.5 mb-8">
          <img src="/logo.png" alt="Earth Nest Organics logo" className="h-9 w-9 object-contain" />
          <span className="font-accent text-lg font-extrabold tracking-tight text-[var(--forest)]">EARTH NEST ORGANICS</span>
        </div>
        <h1 className="font-serif-display text-3xl text-[var(--forest)]">Admin Login</h1>
        <p className="text-sm text-[var(--muted)] mt-1">Manage offers, products & ad banners.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-sm font-medium text-[var(--ink)]">Username</label>
            <input data-testid="login-username" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username"
              className="mt-1.5 w-full h-12 rounded-xl border border-[var(--border)] bg-[var(--cream)] px-4 outline-none focus:border-[var(--forest)] transition-colors" />
          </div>
          <div>
            <label className="text-sm font-medium text-[var(--ink)]">Password</label>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password"
              className="mt-1.5 w-full h-12 rounded-xl border border-[var(--border)] bg-[var(--cream)] px-4 outline-none focus:border-[var(--forest)] transition-colors" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-600">{error}</p>}
          <button data-testid="login-submit" disabled={loading}
            className="w-full h-12 rounded-full bg-[var(--forest)] text-[var(--cream)] font-bold uppercase tracking-widest text-sm hover:bg-[var(--forest-2)] transition-colors disabled:opacity-60 flex items-center justify-center gap-2">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Login
          </button>
        </form>
      </div>
    </div>
  );
};
